import { render, staticRenderFns } from "./student-answer.vue?vue&type=template&id=1860cbcb&scoped=true"
import script from "./student-answer.vue?vue&type=script&lang=js"
export * from "./student-answer.vue?vue&type=script&lang=js"
import style0 from "./student-answer.vue?vue&type=style&index=0&id=1860cbcb&prod&lang=less&scoped=true"
import style1 from "./student-answer.vue?vue&type=style&index=1&id=1860cbcb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860cbcb",
  null
  
)

export default component.exports